module.exports = __webpack_public_path__ + "img/UserExperiences.7aa5dd25.svg";